import { useQuery } from '@apollo/client/react'
import { Text } from '@chakra-ui/react'

import { AdminPageLayout } from '../../../components/AdminPageLayout/AdminPageLayout'
import { DataTable } from '../../../components/DataTable'
import { AuditLog, auditLogsQuery } from '../../../services/auditService'
import { useAuditAdminColumns } from './AuditAdminPage.parts'

export const AuditAdminPage = () => {
  const { data, loading: isLoading } = useQuery(auditLogsQuery, {
    variables: {
      first: 200,
      skip: 0,
      filter: undefined,
      orderBy: [{ createdDate: 'DESC' }],
    },
  })
  const auditLogs = ((data as { AuditLog_list?: { items?: AuditLog[] } })
    ?.AuditLog_list?.items ?? []) as AuditLog[]

  const columns = useAuditAdminColumns()

  return (
    <AdminPageLayout pageTitle="Audit">
      <Text mb={4} color="presets.neutral.70">
        Audit log of administrative and system actions.
      </Text>

      <DataTable
        data={auditLogs}
        columns={columns}
        isLoading={isLoading}
        height="calc(100vh - 200px)"
      />
    </AdminPageLayout>
  )
}
